"use strict";

exports.__esModule = true;
exports.useFormRepeat = useFormRepeat;

var _react = require("react");

var _hooks = require("@bydesign-ui/hooks");

var _form = require("../../../models/form");

var _useForm = require("./useForm");

var _useFormScope = require("./useFormScope");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function useFormRepeat(options) {
  var form = (0, _useForm.useForm)();
  var scope = (0, _useFormScope.useFormScope)();

  var _useReactiveState = (0, _hooks.useReactiveState)(function () {
    return new _form.FormRepeat(form, scope, options);
  }, options, function (ins) {
    return ins.getRepeatInfo();
  }),
      instance = _useReactiveState[0],
      state = _useReactiveState[1];

  var onAppend = (0, _react.useCallback)(function (data) {
    return instance.appendRepeatItem(data);
  }, []);
  var onInsert = (0, _react.useCallback)(function (key, data) {
    return instance.insertRepeatItem(key, data);
  }, []);
  var onSort = (0, _react.useCallback)(function (fromKey, toKey) {
    return instance.sortRepeatItem(fromKey, toKey);
  }, []);
  var onRemove = (0, _react.useCallback)(function (key) {
    return instance.removeRepeatItem(key);
  }, []);
  return _extends({}, state, {
    instance: instance,
    onAppend: onAppend,
    onSort: onSort,
    onInsert: onInsert,
    onRemove: onRemove
  });
}